import { Image as ImageType } from '@yleisradio/areena-types';
import Image from 'next/image';
import React from 'react';
import { defaultLoader, loaderUrl } from 'utils/images';
import styles from './OverlayLogoImage.module.scss';

interface OverlayLogoImageProps {
  logoImage: ImageType | undefined;
}

export const OverlayLogoImage: React.FunctionComponent<
  OverlayLogoImageProps
> = ({ logoImage }) => {
  if (!logoImage) return null;
  return (
    <Image
      key={logoImage.id}
      src={loaderUrl(logoImage)}
      alt={logoImage.alt || ''}
      loader={defaultLoader}
      width={150}
      height={32}
      priority
      className={styles.image}
    />
  );
};
